import { render, staticRenderFns } from "./modNavCtrB.vue?vue&type=template&id=c41d5184&"
import script from "./modNavCtrB.vue?vue&type=script&lang=js&"
export * from "./modNavCtrB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports